namespace Gamification.Gamification {
    export interface UtentiProdottiClassiForm {
        IdUtente: Serenity.IntegerEditor;
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdProdottoClasse: Serenity.LookupEditor;
    }

    export class UtentiProdottiClassiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiClassi';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiClassiForm.init)  {
                UtentiProdottiClassiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(UtentiProdottiClassiForm, [
                    'IdUtente', w0,
                    'IdUtenteProdotto', w0,
                    'IdProdottoClasse', w1
                ]);
            }
        }
    }
}
